/**
 * POSSEN — Product page media slider arrows (desktop).
 *
 * The slider itself is CSS: a scroll-snapping overflow container, the same
 * one the phone has always used. This only adds the two controls a mouse
 * needs, because a horizontal scroller is a gesture on a touchscreen and a
 * dead end with a wheel.
 *
 * Deliberately not a carousel library. The scroller stays the source of
 * truth — the arrows just call scrollBy, and the disabled state is read
 * back off scrollLeft. Anything the customer does directly (trackpad pan,
 * keyboard, snap) therefore keeps the buttons honest for free, with no
 * state of our own to drift out of sync.
 */
(function () {
  'use strict';

  /* Matches the breakpoint in pdp-media.css, where the arrows exist at all.
     Below this the page is stacked and touch-first, so the scroller is a
     gesture again and needs no buttons. */
  var DESKTOP = '(min-width: 1200px)';

  function init() {
    var root = document.querySelector('[data-pdp-media]');
    if (!root) return;

    var track = root.querySelector('[data-pdp-track]');
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    if (!track || !prev || !next) return;

    var mq = window.matchMedia(DESKTOP);

    /* Slides are no longer a uniform width — each frame matches its own
       image's aspect — so a fixed step would drift out of alignment after
       the first landscape plate. Scroll to the next slide's actual edge
       instead, which stays right whatever the widths are. */
    function edges() {
      return Array.prototype.slice
        .call(track.querySelectorAll('.mobile-slide'))
        .map(function (slide) { return slide.offsetLeft; });
    }

    function go(direction) {
      var list = edges();
      var here = track.scrollLeft;
      var target = null;
      var i;

      if (direction > 0) {
        for (i = 0; i < list.length; i++) {
          /* A pixel of tolerance: scrollLeft is fractional under zoom. */
          if (list[i] > here + 2) { target = list[i]; break; }
        }
        if (target === null) target = track.scrollWidth;
      } else {
        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] < here - 2) { target = list[i]; break; }
        }
        if (target === null) target = 0;
      }

      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function sync() {
      if (!mq.matches) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      var max = track.scrollWidth - track.clientWidth;
      /* Nothing to scroll: every image already fits. No controls, rather
         than two permanently dead ones. */
      if (max <= 1) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      /* A pixel of tolerance — scrollLeft is fractional under zoom and on
         hidpi, so an exact comparison never reaches the ends. */
      prev.hidden = false;
      next.hidden = false;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      prev.style.opacity = prev.disabled ? '0' : '';
      next.style.opacity = next.disabled ? '0' : '';
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (mq.addEventListener) mq.addEventListener('change', sync);

    /* Images arrive after this runs and change scrollWidth as they land. */
    Array.prototype.slice.call(track.querySelectorAll('img')).forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', sync, { once: true });
      img.addEventListener('error', sync, { once: true });
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
